import React from 'react';
import { useFlag } from '@unleash/proxy-client-react';
import './Step1Type.css';

const Step1Type = ({ formData, onSetFormData }) => {
  // Same flag as the Automations page tabs. When OFF, only Ingest and
  // Reports are offered as automation templates.
  const extraAutomationTypesEnabled = useFlag('enable_extra_automation_types');
  // Alerts is a real template with a wizard behind it, so it has its own flag
  // rather than riding on the placeholder extras (PRD-1248).
  const alertsEnabled = useFlag('enable_alert_automations');

  const allAutomationTypes = [
    { id: 'ingest', label: 'Ingest', description: 'Watch sources and extract data into a dataset.' },
    { id: 'publish', label: 'Publish', description: 'Publish a clean structured view to analytics or downstream tools.' },
    { id: 'join', label: 'Join', description: 'Combine multiple datasets into a derived view.' },
    { id: 'quality', label: 'Quality', description: 'Monitor extraction quality and data health.' },
    { id: 'alerts', label: 'Alerts', description: 'Notify when thresholds or exceptions are met.' },
    { id: 'reports', label: 'Reports', description: 'Schedule queries and snapshots to be delivered.' },
    { id: 'govern', label: 'Govern', description: 'Apply masking, archiving, and retention policies.' },
    { id: 'review', label: 'Review', description: 'Turn issues into review tasks.' },
    { id: 'custom', label: 'Custom', description: 'Define your own conditions and actions.' },
  ];

  const automationTypes = allAutomationTypes.filter((t) => {
    if (t.id === 'ingest' || t.id === 'reports') return true;
    if (t.id === 'alerts') return alertsEnabled;
    return extraAutomationTypesEnabled;
  });

  const handleTypeSelect = (typeId) => {
    onSetFormData({ ...formData, type: typeId });
    // For Ingest, we'll proceed automatically (handled by parent)
  };

  return (
    <div className="step-content">
      <h3 className="step-title">Choose automation template</h3>
      <div className="automation-types-grid">
        {automationTypes.map((type) => (
          <div
            key={type.id}
            className={`automation-type-card ${formData.type === type.id ? 'selected' : ''}`}
            onClick={() => handleTypeSelect(type.id)}
          >
            <div className="automation-type-label">{type.label}</div>
            <div className="automation-type-description">{type.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step1Type;


